<template>
  <form class="o-form" @submit.prevent="submit">
    <slot name="header" />
    <slot name="row" />
    <slot name="formButtons" />
  </form>
</template>

<script>
import addSlotClasses from '@/components/deprecated/mixins/slotClassAddition';

export default {
  name: 'VForm',
  introduction: 'A skeleton for laying out forms.',
  mixins: [addSlotClasses],
  props: {
    onSubmit: {
      type: [Function],
      note: 'A function called on form submit.',
    },
  },
  data() {
    return {
      headerClass: 'o-form__header',
      rowClass: 'o-form__row',
      formButtonsClass: 'o-form__buttons',
    };
  },
  mounted() {
    this.addSlotClasses();
  },
  updated() {
    this.addSlotClasses();
  },
  methods: {
    submit() {
      const validationScope = this.$el.getAttribute('data-vv-scope');
      this.onSubmit(validationScope);
    },
  },
};
</script>

<style scoped>
.o-form:after {
  content: '';
  display: block;
  clear: both;
}

.o-form__row {
  margin-top: var(--spacing-base);
}

.o-form__row:after {
  content: '';
  display: block;
  clear: both;
}

.o-form__row:first-child {
  margin-top: 0;
}

.o-form__row ::v-deep b {
  display: block;
  margin-bottom: var(--spacing-xs);
}

.o-form__row ::v-deep .a-message {
  margin-top: var(--spacing-small);
}

.o-form__row--split {
  margin-top: var(--spacing-base);
  padding-top: var(--spacing-base);
  border-top: 1px solid var(--color-border);
}

.o-form__buttons {
  padding-top: var(--spacing-base);
}

.o-form__buttons:after {
  content: '';
  display: block;
  clear: both;
}

.o-form__buttons a {
  margin-left: var(--spacing-base);
}

.o-form__buttons a:first-child {
  margin-left: 0;
}

.o-form__buttons--right {
  float: right;
}

.o-form__buttons--left {
  float: left;
}
</style>
